import { useEffect, useMemo, useRef } from 'preact/hooks';
import { renderMarkdown } from '../util/markdown';
import { reviewSnippet } from '../state/actions';
import { showToast } from '../state/store';

const TOOLBAR_HTML = `
  <span class="codeblock-tools">
    <button type="button" class="codeblock-btn" data-act="copy" title="Copy">Copy</button>
    <button type="button" class="codeblock-btn" data-act="insert" title="Put this code in the editor and review the diff">To editor</button>
  </span>`;

function decorate(root: HTMLElement): void {
  for (const pre of root.querySelectorAll<HTMLPreElement>('pre.codeblock')) {
    if (pre.querySelector('.codeblock-tools')) continue;
    pre.insertAdjacentHTML('afterbegin', TOOLBAR_HTML);
  }
}

export function Markdown({ source, class: className }: { source: string; class?: string }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) decorate(ref.current);
  }, [html]);

  const onClick = (event: MouseEvent) => {
    const button = (event.target as HTMLElement).closest<HTMLButtonElement>('.codeblock-btn');
    if (!button) return;
    const pre = button.closest<HTMLPreElement>('pre.codeblock');
    const code = pre?.querySelector('code')?.textContent ?? '';
    if (button.dataset.act === 'copy') {
      void navigator.clipboard.writeText(code).then(
        () => showToast('Copied.'),
        () => showToast('Could not copy to the clipboard.', 'error'),
      );
    } else if (button.dataset.act === 'insert') {
      reviewSnippet(code, pre?.dataset.lang ?? '');
    }
  };

  return <div ref={ref} class={`markdown${className ? ` ${className}` : ''}`} onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />;
}
